export default {
  default: true,
  feature1: false,
  feature2: false
};
